import { render, staticRenderFns } from "./infoCentreImport.vue?vue&type=template&id=300a0c4e"
import script from "./infoCentreImport.vue?vue&type=script&lang=js"
export * from "./infoCentreImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports